module.exports = __webpack_public_path__ + "img/pet.efa096b8.gif";